/** @param {(key: string) => string} tk */
export function getProductFields(tk, categories) {
  return [
    {
      name: "name_ar",
      label: tk("fields.nameAr"),
      type: "text",
      required: true,
    },
    {
      name: "name_en",
      label: tk("fields.nameEn"),
      type: "text",
      required: true,
    },
    {
      name: "category_id",
      label: tk("fields.category"),
      type: "select",
      required: true,
      placeholder: tk("fields.categoryPlaceholder"),
      options: categories.map((c) => ({
        value: String(c.id),
        label: c.label,
      })),
    },
    {
      name: "description_ar",
      label: tk("fields.descriptionAr"),
      type: "textarea",
      rows: 4,
    },
    {
      name: "description_en",
      label: tk("fields.descriptionEn"),
      type: "textarea",
      rows: 4,
    },
    {
      name: "is_featured",
      label: tk("fields.featured"),
      type: "checkbox",
      checkboxLabel: tk("fields.featuredCheckbox"),
    },
    {
      name: "image",
      label: tk("fields.mainImage"),
      type: "file",
      maxFileMB: 2,
      hint: tk("hints.mainImage"),
    },
    {
      name: "gallery",
      label: tk("fields.gallery"),
      type: "file",
      multiple: true,
      maxFileMB: 2,
      hint: tk("hints.gallery"),
    },
  ];
}
